
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/components/auth/AuthProvider";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import Index from "./pages/Index";
import Project from "./pages/Project";
import Inventory from "./pages/Inventory";
import Contacts from "./pages/Contacts";
import Account from "./pages/Account";
import Help from "./pages/Help";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import AcceptInvite from "./pages/AcceptInvite";
import SubscriptionVerification from "./pages/SubscriptionVerification";
import PublicInventoryView from "./pages/PublicInventoryView";
import PublicProjectView from "./pages/PublicProjectView";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <AuthProvider>
            <CurrencyProvider>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/project/:projectId" element={<Project />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/account" element={<Account />} />
                <Route path="/help" element={<Help />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/accept-invite/:invitationId" element={<AcceptInvite />} />
                <Route path="/subscription-verification" element={<SubscriptionVerification />} />
                <Route path="/public/inventory/:token" element={<PublicInventoryView />} />
                <Route path="/public-project/:token" element={<PublicProjectView />} />
              </Routes>
            </CurrencyProvider>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
